const styles = (theme) => ({
  details: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  headerTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    p: 1,
  },
  title: { fontWeight: "bold", fontSize: "20px" },
  subtitle: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
    maxWidth: "760px",
  },
  infoAlert: {
    borderRadius: "12px",
    width: "fit-content",
    maxWidth: "100%",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1.5,
  },
  toolbarCount: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  lista: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  loadingState: {
    display: "flex",
    justifyContent: "center",
    padding: "40px 0",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
    padding: "48px 16px",
    borderRadius: "16px",
    border: `1px dashed ${theme.palette.divider}`,
    textAlign: "center",
  },
  emptyIcon: {
    fontSize: "40px",
    color: theme.palette.text.disabled,
    mb: 1,
  },
  emptyTitle: {
    fontWeight: 600,
  },
  emptyDescription: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
  },
});

export default styles;
